export default () => `
  {
    currentStore {
      shipping {
        cost
        threshold
      }
      currency {
        code
        symbol
        thousandsSeparator
        decimalMark
        symbolFirst
      }
      customerServiceEmail
      customerServicePhone
    }
  }
`
